import React ,{ useState } from "react";
import { ToolTip } from "../../../AbstractElements";

/** 
 * placement, target
 */
const CommonToolTip=(props)=> {
  const [basictooltip, setbasictooltip] = useState(false);
  const toggle = () => setbasictooltip(!basictooltip);
  return (
    <ToolTip
      attrToolTip={{
        ...props.options,
        isOpen: basictooltip,
        toggle: toggle,
      }}
    >
      {props.children}
    </ToolTip>
  );
}

export default CommonToolTip;
